// @flow

import {DateTime as LuxonDateTime} from 'luxon';
import type {Config} from 'docs/markdoc';

export class DateTime {
  validate(value: any, config: Config) {
    if (typeof value !== 'string' || isNaN(Date.parse(value)))
      return [
        {
          id: 'invalid-datetime-type',
          level: 'critical',
          message: 'Must be a string with a valid date format',
        },
      ];

    return [];
  }

  render(value: any, config: Config) {
    return LuxonDateTime.fromISO(value).toMillis();
  }
}
